import React, { useEffect, useState } from "react";
import axios from "axios";
import { FaEdit, FaTrash } from "react-icons/fa";
import AddGiftModal from "../components/Addgifts";
import Sidebar from "../components/Sidebar";
import Topbar from "../components/Topbar";
// import "../styles/gifts.css";
import '../App.css'
import { ApiUrl } from '../Constants/Weburl'
import CustomButton from "../components/CustomButton";
import CustomCard from "../components/CustomCard";
import { useSearchParams } from "react-router-dom";
import DeleteModal from "../components/DeleteModal";
import Layout from "../components/Layout";
import CustomContainer from "../components/Customsettingscontain";

export default function Gifts() {
  const [gifts, setGifts] = useState([]);
  const [open, setOpen] = useState(false);
  const [editGift, setEditGift] = useState(null);

  const [searchParams] = useSearchParams();
  const searchCoins = searchParams.get("search") || "";

  //delete modal 
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState(null);

  const fetchGifts = async () => {
    const res = await axios.get(`${ApiUrl}api/getgifts`);
    setGifts(res.data.data);
    console.log("getgifts", res.data.data)
  };


  useEffect(() => {
    fetchGifts();
  }, []);

  // const displayedGifts = searchCoins
  //   ? gifts.filter((g) => String(g.coins) === String(searchCoins))
  //   : gifts;

  const searchId = searchParams.get("id");

const numericTerm = searchCoins.match(/[\d.]+/)?.[0];

const displayedGifts = searchCoins
  ? gifts.filter((g) => {
      if (searchId && String(g.id) === String(searchId)) return true;
      if (numericTerm && String(g.coins) === String(numericTerm)) return true;
      return false;
    })
  : gifts;

  //delete gifts
  const deleteGift = async (id) => {

    try {
      const res = await axios.delete(`${ApiUrl}api/gifts/${id}`);

      console.log("Delete response:", res.data);

      if (res.data.success) {
        fetchGifts();
        setShowDeleteModal(false);
        setDeleteId(null);
      }
      else {
        alert("Delete Failed")
      }
    } catch (error) {
      console.error("Delete error:", error);

      alert(
        error.response?.data?.message || "Something went wrong"
      );
    }

    // fetchGifts();
  };


  //edit gifts
  const handleEdit = (gift) => {
    setEditGift(gift);
    setOpen(true);
  };




  return (
    <div className="layout">
        <Layout>

        {/* <div className="gifts-header">
        <h2>GIFTS</h2>
        <button className="add-btn" onClick={() => setOpen(true)}>
          Add Gift
        </button>
      </div> */}

        <CustomContainer className="rr-wrapperhashtag" fluid="false">

        <div className="rr-card">
          <div className="users-tabs-row">
            <h4>GIFTS</h4>
            {searchCoins && (
              <span style={{ marginLeft: '15px', fontSize: '14px', color: '#666' }}>
                Showing results for: <strong>"{numericTerm || searchCoins} coins"</strong>
              </span>
            )}
            {/* <button className="rr-add-btn" onClick={() => setOpen(true)}>
              Add Gift
            </button> */}
            <CustomButton variant="dark" onClick={() => { setEditGift(null); setOpen(true); }}>
              Add Gift
            </CustomButton>
          </div>
        </div>
        {/* <div className="rr-wrapper"> */}
          <div className="gifts-grid">
            {displayedGifts.length === 0 ? (
              <p style={{ padding: 20 }}>
                {searchCoins ? `No gift found with ${numericTerm || searchCoins} coins` : "No gifts found"}
              </p>
            ) : (
              displayedGifts.map((gift) => (
                <CustomCard
                  key={gift.id}
                  image={`${ApiUrl}uploadsgifts/${gift.image}`}
                  title={`${gift.coins} Coins`}
                  className="gift-card"
                  imgClassName="gift-img"
                  titleClassName="coins"
                >
                  <div className="actions">
                    <CustomButton
                      // className="edit" 
                      variant="edit"
                      onClick={() => handleEdit(gift)}>
                      <i className="bi bi-pencil"></i>
                    </CustomButton>
                    <CustomButton
                      variant="delete"
                      onClick={() => {
                        setDeleteId(gift.id);
                        setShowDeleteModal(true);
                      }}
                    >
                      <i className="bi bi-trash"></i>
                    </CustomButton>


                  </div>
                </CustomCard>
              ))
            )}
          </div>


          <DeleteModal
            show={showDeleteModal}
            close={() => {
              setShowDeleteModal(false);
              setDeleteId(null);
            }}
            onDelete={() => deleteGift(deleteId)}
            title="Delete Gift"
            message="Are you sure you want to delete this gift?"
          />

          {open && (
            <AddGiftModal
              close={() => { setOpen(false); setEditGift(null); }}
              //   refresh={fetchGifts}
              refresh={fetchGifts}
              editGift={editGift}
            />
          )}


        {/* </div>   */}
        </CustomContainer>
        </Layout>
      </div>
    
    // </div>
  );
}
